import React, { FC, Dispatch, SetStateAction } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface RadioOption {
  label: string;
  value: string;
  color?: string;
}

interface InspectionRadioGroupProps {
  label?: string;
  radioOptions: RadioOption[];
  value: any;
  setValue: Dispatch<SetStateAction<any>>;
}

const colorMap: Record<string, { border: string; bg: string; selectedBg: string; text: string }> = {
  good: { border: '#4caf50', bg: '#fff', selectedBg: '#4caf50', text: '#fff' },
  yes: { border: '#4caf50', bg: '#fff', selectedBg: '#4caf50', text: '#fff' },
  needs_attention: { border: '#ff9800', bg: '#fff', selectedBg: '#ff9800', text: '#fff' },
  requires_service: { border: '#f44336', bg: '#fff', selectedBg: '#f44336', text: '#fff' },
  no: { border: '#f44336', bg: '#fff', selectedBg: '#f44336', text: '#fff' },
};

const defaultColors = { border: '#90a4ae', bg: '#fff', selectedBg: '#546E7A', text: '#fff' };

const InspectionRadioGroup: FC<InspectionRadioGroupProps> = ({ label, radioOptions, value, setValue }) => {
  const optionCount = radioOptions.length;
  const gridXs = optionCount === 2 ? 6 : 4;

  return (
    <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
      {label && (
        <Grid item xs={12} md={4}>
          <Typography sx={{ fontWeight: 500, mb: { xs: 0.5, md: 0 } }}>{label}</Typography>
        </Grid>
      )}
      <Grid item xs={12} md={label ? 8 : 12}>
        <Grid container spacing={1}>
          {radioOptions.map((opt) => {
            const isSelected = opt.value.toString() === value?.toString();
            const colors = colorMap[opt.value] || defaultColors;

            return (
              <Grid item xs={gridXs} key={opt.value}>
                <Button
                  variant={isSelected ? 'contained' : 'outlined'}
                  fullWidth
                  onClick={() => setValue(opt.value)}
                  sx={{
                    minHeight: { xs: 42, md: 36 },
                    fontSize: { xs: '11px', md: '13px' },
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    px: 0.5,
                    lineHeight: 1.2,
                    borderColor: colors.border,
                    borderWidth: '2px',
                    color: isSelected ? colors.text : colors.border,
                    bgcolor: isSelected ? colors.selectedBg : colors.bg,
                    '&:hover': {
                      borderColor: colors.border,
                      borderWidth: '2px',
                      bgcolor: isSelected ? colors.selectedBg : `${colors.border}14`,
                    },
                  }}
                >
                  {opt.label}
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InspectionRadioGroup;
